var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMNftIssuer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2733 30.6362C32.8029 28.7998 36.0029 24.3094 36.0029 19.0612C36.0029 12.1791 30.5003 6.6 23.7124 6.6C16.9246 6.6 11.422 12.1791 11.422 19.0612C11.422 24.3086 14.621 28.7984 19.1495 30.6353C7.27259 33.6955 0 47.7342 0 47.7342V60.0002H47.4196V47.7342C47.4196 47.7342 40.1483 33.698 28.2733 30.6362Z",
    fill: "#FEA005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7175 11.0377C46.6285 14.3358 51.0005 18 51.0005 18C51.0005 18 55.577 13.9677 57.2835 11.0377C59.2134 7.72424 60.0005 1.84085 60.0005 1.84085C60.0005 1.84085 56.5618 0 51.0005 0C45.4392 0 42.0005 1.84085 42.0005 1.84085C42.0005 1.84085 42.9257 7.94548 44.7175 11.0377Z",
    fill: "#FEA005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMNftIssuer);
export default __webpack_public_path__ + "static/media/m_nft_issuer.e283fc2e3301f6c7508bfb0dff2108a2.svg";
export { ForwardRef as ReactComponent };